import { Star } from "lucide-react";

export const InteractiveHistogram = ({ histogram, total, selectedRating, onSelectRating }) => {
  return (
    <div className="space-y-1.5">
      <button
        onClick={() => onSelectRating(null)}
        className={`w-full text-left px-2 py-1 rounded text-xs transition-colors ${
          selectedRating === null ? "bg-amber-500/20 text-amber-500" : "text-zinc-400 hover:text-white"
        }`}
      >
        Todas ({total})
      </button>
      {[5, 4, 3, 2, 1].map((rating) => {
        const count = histogram[rating] || 0;
        const percentage = total > 0 ? (count / total) * 100 : 0;
        const isSelected = selectedRating === rating;
        
        return (
          <button
            key={rating}
            onClick={() => onSelectRating(rating)}
            className={`w-full flex items-center gap-2 text-xs p-1 rounded transition-colors ${
              isSelected ? "bg-amber-500/20" : "hover:bg-white/5"
            }`}
          >
            <span className="w-3 text-zinc-400">{rating}</span>
            <Star size={10} className="text-amber-500 fill-amber-500" />
            <div className="flex-1 h-1.5 bg-zinc-800 rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-amber-500 to-amber-400 rounded-full transition-all" 
                style={{ width: `${percentage}%` }} 
              />
            </div>
            <span className="w-6 text-right text-zinc-500">{count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default InteractiveHistogram;
